import React from 'react';

export const matchSearchQuery = (value: string, query: string) => {
    const stringToReplace = value.toLowerCase();
    const startMatchIndex = stringToReplace.indexOf(query.toLocaleLowerCase());
    if (startMatchIndex > -1) {
        return (
            <>
                {value.substring(0, startMatchIndex)}
                <mark>{value.substring(startMatchIndex, startMatchIndex + query.length)}</mark>
                {value.substring(startMatchIndex + query.length)}
            </>
        );
    }
    return value;
};
